import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { Paper, Tab } from '@mui/material';
import React, { SyntheticEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import useLocales from 'src/hooks/useLocales';
import { useAppSelector } from 'src/redux/store';
import { tabStyles } from 'src/utils/tabStyles';
import { EnqueteConfirmTab } from '../../shared-tabs/answer-confirm-status/components/EnqueteConfirmTab';
import OutsideSurveyPeriodTypography from '../../shared-tabs/outside-survey/components/OutsideSurveyPeriodTypography';
import { EnqueteAnswerSeriesSurveyTab } from './tabs/components/EnqueteAnswerSeriesSurveyTab';

const TAB_VALUE = {
  QUESTION: 'seriesQuestion',
  CONFIRM: 'EnqueteStatus',
  CHANGE: 'ChangeRespondents',
} as const;
type TabValue = typeof TAB_VALUE[keyof typeof TAB_VALUE];

export const SeriesSurveyTabContainer: React.FC = () => {
  // 依頼期間前かの情報を格納
  const isBeforeRequestTerm = useAppSelector((state) => state.enqueteAnswer.isBeforeRequestTerm);
  const { t } = useTranslation();
  const { currentLang } = useLocales();
  // タブ切り替え
  const handleChange = (_event: SyntheticEvent, newValue: TabValue) => {
    setTabValue(newValue);
  };
  const params = useLocation().search;
  // URLに含まれるTabパラメータを取得
  const tabParmsValue = new URLSearchParams(params).get('tab');
  const defaultTab = tabParmsValue ? tabParmsValue : TAB_VALUE.QUESTION;
  const [tabValue, setTabValue] = useState<TabValue>(defaultTab as TabValue);

  return (
    <TabContext value={tabValue}>
      <Paper variant="elevation">
        <TabList onChange={handleChange}>
          <Tab
            style={tabStyles(currentLang.value)}
            label={t('enqueteAnswerInput.tab.seriesSurvey')}
            value={TAB_VALUE.QUESTION}
            sx={{ paddingLeft: 2 }}
            disabled={isBeforeRequestTerm}
          />
          <Tab
            style={tabStyles(currentLang.value)}
            label={t('enqueteAnswerInput.tab.responseConfirmationStatus')}
            value={TAB_VALUE.CONFIRM}
            disabled={isBeforeRequestTerm}
          />
        </TabList>
        {/** アンケートコンポーネント */}
        <TabPanel value={TAB_VALUE.QUESTION}>
          {isBeforeRequestTerm ? <OutsideSurveyPeriodTypography requestStatus={'before'} /> : <EnqueteAnswerSeriesSurveyTab />}
        </TabPanel>
        {/** 回答確認状況コンポーネント */}
        <TabPanel value={TAB_VALUE.CONFIRM}>
          {isBeforeRequestTerm ? <OutsideSurveyPeriodTypography requestStatus={'before'} /> : <EnqueteConfirmTab />}
        </TabPanel>
      </Paper>
    </TabContext>
  );
};
